import { render, staticRenderFns } from "./componentDesc.vue?vue&type=template&id=f1d6e42e&scoped=true&"
import script from "./componentDesc.vue?vue&type=script&lang=ts&"
export * from "./componentDesc.vue?vue&type=script&lang=ts&"
import style0 from "./componentDesc.vue?vue&type=style&index=0&id=f1d6e42e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d6e42e",
  null
  
)

export default component.exports